<template>
  <!-- full-screen blocking overlay shown while any API request is pending; sits above all other UI -->
  <div
    v-if="loading.isLoading"
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-gray-500 bg-opacity-75"
  >
    <div class="h-24 w-24 animate-spin rounded-full border-4 border-gray border-t-4 border-t-red-500" />
  </div>
</template>

<script setup lang="ts">
import { useGlobalLoadingStore } from '~/composables/stores/GlobalLoadingStore';

const loading = useGlobalLoadingStore();
</script>
